export default {
  zh: {
    tabs: {
      dataType: 'Dashboard类型',
      reports: '报告'
    }
  },
  en: {
    tabs: {
      dataType: 'Data Type',
      reports: 'Report Data'
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/DashboardSettings/i18n.js